import { fromEntries } from 'betterplace-utils'
import getPublicUrl from '../getPublicUrl'
import { toPathFactory } from '../toPathFactories'
import type { ToPathFactory } from '../toPathFactories/toPathFactories'
import routeManifest from './routeManifest'
import routesSearchParams from './routesSearchParams'
import servedFromWWW from './servedFromWWW'
import type { AppRouteToName, AppRoutes } from './types'

function isKeyOf<T extends object>(obj: T, key: PropertyKey): key is keyof T {
  return key in obj
}

export type RouteDefinitions<TConstr extends AppRoutes = AppRoutes> = Readonly<{
  [TRoute in TConstr as AppRouteToName<TRoute>]: ToPathFactory<`${TRoute}${AppRouteToName<TRoute> extends keyof typeof routesSearchParams ? (typeof routesSearchParams)[AppRouteToName<TRoute>] : ''}`>
}>
const Routes = fromEntries(
  routeManifest.map(({ name, route }) => {
    let searchParamStr = ''
    if (isKeyOf(routesSearchParams, name)) {
      searchParamStr = routesSearchParams[name]
    }
    const isWWW = servedFromWWW.has(name)
    const getBaseUrl = getPublicUrl.bind(null, isWWW)
    return [name, toPathFactory(route + searchParamStr, getBaseUrl)] as const
  })
) as RouteDefinitions
export default Routes
